module.exports = __webpack_public_path__ + "static/media/tire-rotation-white.6f91a374.svg";